// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-item {
  --border-width: 1px !important;
  border: none !important;
  --border-radius: 16px !important;
}

ion-input {
  --border: none !important;
  color: var(--ion-color-secondary);
  font-family: AppFont, sans-serif;
}

.no-line {
  border-bottom: 0px;
  --background: transparent ;
}

.wrapper {
  padding: 20px;
}

.privacy {
  font-size: 12px;
  color: var(--ion-color-black);
}
.privacy ion-button {
  padding: 0px;
  color: var(--ion-color-primary);
  text-transform: capitalize;
}

.privacy-btn {
  z-index: 999;
  margin-left: 5px;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-item {
  --border-radius: 5px;
  margin-bottom: 0;
}

.stacked {
  position: relative;
  z-index: 2;
  left: 20px;
  top: 7px;
  background: white;
  padding: 0px 5px;
}

.terms {
  min-width: 360px;
  margin-left: 0px;
}
.terms ion-checkbox {
  margin-right: 10px;
}

ion-checkbox {
  margin-left: 0px;
}

.stacked {
  position: static;
  top: 0px;
  left: 0px;
  z-index: 2;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--ion-color-secondary);
}

.input-age ion-input {
  height: 100%;
  text-align: center;
  color: var(--ion-color-secondary);
}
.input-age ion-input:first-child {
  border-right: 1px solid #CBD5E1;
}
.input-age ion-input:last-child {
  border-left: 1px solid #CBD5E1;
}

ion-footer {
  --background: transparent;
  box-shadow: none;
}

.loading {
  height: 50vh;
  align-items: center;
}

.label {
  position: relative;
  top: 9px;
  left: 17px;
  background: white;
  z-index: 2;
  padding-inline: 5px;
  font-family: SecondaryFontSemiBold;
  font-size: 11px;
  line-height: 20px;
  text-align: left;
  text-transform: capitalize;
  color: #BCB3AA;
}

.wrap h1 {
  font-size: 18px;
}
.wrap .text-large {
  font-size: 14px;
}
.wrap ion-item {
  --border-color: #e6e7e3;
  --border-width: 1px !important;
}
.wrap .block_info {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
}
.wrap .block_info .resend_btn {
  background: var(--ion-color-primary);
  font-size: 12px;
  width: -moz-fit-content;
  width: fit-content;
  padding: 15px;
  color: white;
  border-radius: 50px;
}

.delete-section {
  display: flex;
  justify-content: center;
}
.delete-section ion-button {
  --background: transparent;
  border: 1px solid #ED6958;
  border-radius: 16px;
  color: #ED6958;
}

ion-header {
  box-shadow: none;
}

.button-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
  flex-wrap: wrap;
}
.button-wrapper ion-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 5px 8px;
}
.button-wrapper ion-button p {
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  color: white;
  width: 75%;
}
.button-wrapper ion-button ion-icon {
  margin-right: 10px;
  zoom: 0.9;
}
.button-wrapper ion-button.google {
  --background: #D0463B;
}
.button-wrapper ion-button.facebook {
  --background: #3B5997;
}
.button-wrapper ion-button.apple {
  --background: black;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-data/user-data.page.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;AADF;;AAIA;EACE,QAAA;EACA,kBAAA;AADF;;AAGA;EACE,8BAAA;EACA,uBAAA;EACA,gCAAA;AAAF;;AAEA;EACE,yBAAA;EACA,iCAAA;EACA,gCAAA;AACF;;AACA;EACE,kBAAA;EACA,0BAAA;AAEF;;AAAA;EACE,aAAA;AAGF;;AADA;EACE,eAAA;EACA,6BAAA;AAIF;AAHE;EACE,YAAA;EACA,+BAAA;EACA,0BAAA;AAKJ;;AAFA;EACE,YAAA;EACA,gBAAA;AAKF;;AAFA;EACE,eAAA;EACA,mBAAA;AAKF;;AAFA;EACE,oBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,gBAAA;EACA,gBAAA;AAKF;AAJE;EACE,kBAAA;AAMJ;;AAFA;EACE,gBAAA;AAKF;;AADA;EACC,gBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAID;;AAFA;EACE,oCAAA;EACA,eAAA;EACA,iCAAA;AAKF;;AAFE;EACE,YAAA;EACA,kBAAA;EACA,iCAAA;AAKJ;AAHE;EACE,+BAAA;AAKJ;AAHE;EACE,8BAAA;AAKJ;;AAFA;EACE,yBAAA;EACA,gBAAA;AAKF;;AAHA;EACE,YAAA;EACA,mBAAA;AAMF;;AAFA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EAEA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;AAIF;;AADE;EACE,eAAA;AAIJ;AAFE;EACE,eAAA;AAIJ;AAFE;EACE,uBAAA;EACA,8BAAA;AAIJ;AADE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAGJ;AAFI;EACE,oCAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AAIN;;AAAA;EACE,aAAA;EACA,uBAAA;AAGF;AAFE;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AAIJ;;AAAA;EACE,gBAAA;AAGF;;AADA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAIF;AAHE;EAEE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AAIJ;AAHI;EACI,eAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AAKR;AAHI;EACI,kBAAA;EACA,SAAA;AAKR;AAHI;EACI,qBAAA;AAKR;AAHI;EACI,qBAAA;AAKR;AAHI;EACI,mBAAA;AAKR","sourcesContent":["@import \"../../../theme/mixins\";\n\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n  gap: 5px;\n  margin-bottom: 8px;\n}\nion-item {\n  --border-width: 1px !important;\n  border: none !important;\n  --border-radius: 16px !important;\n}\nion-input {\n  --border: none !important;\n  color: var(--ion-color-secondary);\n  font-family: AppFont, sans-serif;\n}\n.no-line {\n  border-bottom: 0px;\n  --background: transparent\n}\n.wrapper{\n  padding: 20px;\n}\n.privacy{\n  font-size: 12px;\n  color: var(--ion-color-black);\n  ion-button {\n    padding: 0px;\n    color: var(--ion-color-primary);\n    text-transform: capitalize;\n  }\n}\n.privacy-btn{\n  z-index: 999;\n  margin-left: 5px;\n}\n\nion-note {\n  font-size: 12px;\n  padding-right: 10px;\n}\n\nion-item {\n  --border-radius: 5px;\n  margin-bottom: 0;\n}\n\n.stacked {\n  position: relative;\n  z-index: 2;\n  left: 20px;\n  top: 7px;\n  background: white;\n  padding: 0px 5px;\n}\n\n.terms {\n  min-width: 360px;\n  margin-left: 0px;\n  ion-checkbox {\n    margin-right: 10px;\n  }\n}\n\nion-checkbox {\n  margin-left: 0px;\n}\n\n\n.stacked {\n\tposition: static;\n\ttop: 0px;\n\tleft: 0px;\n\tz-index: 2;\n}\nion-label {\n  font-family: AppFontBold, sans-serif;\n  font-size: 16px;\n  color: var(--ion-color-secondary);\n}\n.input-age {\n  ion-input {\n    height: 100%;\n    text-align: center;\n    color: var(--ion-color-secondary);\n  }\n  ion-input:first-child {\n    border-right: 1px solid #CBD5E1;\n  }\n  ion-input:last-child {\n    border-left: 1px solid #CBD5E1;\n  }\n}\nion-footer {\n  --background: transparent;\n  box-shadow: none;\n}\n.loading {\n  height: 50vh;\n  align-items: center;\n}\n\n\n.label {\n  position: relative;\n  top: 9px;\n  left: 17px;\n  background: white;\n  z-index: 2;\n  padding-inline: 5px;\n\n  font-family: SecondaryFontSemiBold;\n  font-size: 11px;\n  line-height: 20px;\n  text-align: left;\n  text-transform: capitalize;\n  color: #BCB3AA;\n}\n.wrap {\n  h1 {\n    font-size: 18px;\n  }\n  .text-large {\n    font-size: 14px;\n  }\n  ion-item {\n    --border-color: #e6e7e3;\n    --border-width: 1px !important;\n\n  }\n  .block_info {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: 15px;\n    .resend_btn {\n      background: var(--ion-color-primary);\n      font-size: 12px;\n      width: fit-content;\n      padding: 15px;\n      color: white;\n      border-radius: 50px;\n    }\n  }\n}\n.delete-section {\n  display: flex;\n  justify-content: center;\n  ion-button {\n    --background: transparent;\n    border: 1px solid #ED6958;\n    border-radius: 16px;\n    color: #ED6958;\n  }\n}\n\nion-header {\n  box-shadow: none;\n}\n.button-wrapper {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin-top: 20px;\n  flex-wrap: wrap;\n  ion-button {\n\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin: 5px 8px;\n    p {\n        margin-top: 5px;\n        font-family: AppFontBold, sans-serif;\n        color: white;\n        width: 75%;\n    }\n    ion-icon {\n        margin-right: 10px;\n        zoom: 0.9;\n    }\n    &.google {\n        --background: #D0463B;\n    }\n    &.facebook {\n        --background: #3B5997;\n    }\n    &.apple {\n        --background: black;\n    }\n}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
